<template>
  <div class="flex flex-wrap profile_img_holder">
    <div
      v-if="image !== ''"
      class="profile_image"
      :style="{
        backgroundImage: 'url(' + image + ')',
        backgroundColor: '#ffffff',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain'
      }"
      @mouseover="profileHover = true"
      @mouseleave="profileHover = false"
    >
      <div
        v-if="profileHover"
        class="hoverProfileImageClass"
        style="height:100%;width:100%;border-radius:50%;"
      >
        <label
          for="uploads"
          style="background-color:transparent;height:100%;width:100%;text-align:center;display:flex;justify-content:center;"
        >
          <vs-icon
            icon-pack="feather"
            icon="icon-upload-cloud"
            style="color:white;margin-top:29%;font-size:30px;"
          ></vs-icon>
        </label>
        <input
          id="uploads"
          type="file"
          style="position:absolute; clip:rect(0 0 0 0);"
          accept="image/png, image/jpeg, image/gif, image/jpg"
          @change="uploadImg($event, 1)"
        />
      </div>
    </div>
    <div v-else>
      <div
        :style="{
          backgroundImage: 'url(' + noProfileImages + ')',
          backgroundColor: '#ffffff',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain'
        }"
        class="profile_image"
        @mouseover="profileHover = true"
        @mouseleave="profileHover = false"
      >
      <div
          v-if="profileHover"
          class="hoverProfileImageClass"
          style="height:100%;width:100%;border-radius:50%;"
        >
          <label
            for="uploads"
            style="background-color:transparent;height:100%;width:100%;text-align:center;display:flex;justify-content:center;"
          >
            <vs-icon
              icon-pack="feather"
              icon="icon-upload-cloud"
              style="color:white;margin-top:29%;font-size:30px;"
            ></vs-icon>
          </label>
          <input
            id="uploads"
            type="file"
            style="position:absolute; clip:rect(0 0 0 0);"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="uploadImg($event, 1)"
          />
        </div>
      </div>
    </div>
     <div class="mt-2 upload_row_holder">
     <vs-tooltip class="inline-block align-bottom gdrive_tooltip" color="primary"
                text="Select image From Gdrive"
              >
                <vs-button
                  class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
                  color="primary"
                  type="border"
                  @click="driveIconClicked()"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
                </vs-button>
              </vs-tooltip>
               <vs-tooltip class="inline-block align-bottom file_tooltip" color="primary"
                text="Import File From Your Existing System"
              >
                <vs-button
                  icon="folder_special"
                  class="mb-6 mx-1 icon_large_btn"
                  color="primary"
                  type="border"
                  @click="isBrowseContent = true"
                  ></vs-button
                >
              </vs-tooltip>
     </div>
    <vs-popup title="Edit Image" :active.sync="editImagePopup" classContent="popup-example">
      <vs-row>
        <vs-col :vs-sm="12">
          <div id="app" style="height:400px;">
            <cropper
              :src="imageDataUrl"
              :stencil-props="{
                minAspectRatio: 10/10,
                maxAspectRatio: 10/10
              }"
              class="cropper"
              @change="onChange"
            ></cropper>
          </div>
        </vs-col>
      </vs-row>
      <vs-row vs-justify="flex-end" class="mt-2">
        <vs-button color="primary" type="filled" @click="saveImage" class="mr-3">Save</vs-button>
        <vs-button color="danger" type="filled" @click="cancelImageUpload">Cancel</vs-button>
      </vs-row>
    </vs-popup>
     <div v-if="isBrowseContent">
      <vs-popup fullscreen title="Browse Item" :active.sync="isBrowseContent">
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="multipleSelect"
        ></import-browse-files-model>
      </vs-popup>
    </div>     
  </div>
</template>
<script>
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import {GoogleAuthorizationProfile} from '@/mixins/common/GoogleAuthProfileImg.js'
import { UploadImage } from '@/api/common'
import { repository } from '@/mixins/repository'
export default {
  name: '',
  components:{
    ImportBrowseFilesModel
  },
  mixins:[GoogleAuthorizationProfile, repository],
  props: {
    image: {
      required: true,
      type: String,
      default: () => ''
    },
    platform_module_id:{type:Number, default:0}
  },
  data () {
    return {
      multipleSelect:false,
      isBrowseContent: false,
      profileImage:'https://freedesignfile.com/upload/2017/03/Green-square-modern-background-vector.jpg',
      profileHover: false,
      editImagePopup: false,
      imageDataUrl: null,
      noProfileImages: require('../../assets/no_images/user_no_image.svg'),
      cropImage: null
      
    }
  },
  created () {
    this.getRepositoryId(this.platform_module_id)
  },
  methods: {
    getImportFile ({ file_id, fileInfo }) {
      this.$vs.notify({
        title: 'Success',
        text: 'File Uploaded Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 1000
      })        
      this.isBrowseContent = false
      this.$emit('changingImage',fileInfo[0].file_path)
    },
    uploadImg (e, num) {
      const file = e.target.files[0]
      const FileType = file.type
      this.fileName = FileType.replace('/', '.')
      const fileSize = ((e.target.files[0].size / 1024) / 1024)
      if (fileSize < 5) {
        // this.dialogVisible = true
        // 
        // if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        //   alert('File Should be must this (.gif,jpeg,jpg,png,bmp) type')
        //   return false
        // }
        const reader = new FileReader()
        reader.onload = (e) => {
          const formData = new FormData()
          formData.append('myFile', file)
          let data = null
          if (typeof e.target.result === 'object') {
            data = window.URL.createObjectURL(new Blob([e.target.result]))
            // fd.append('upload_path', 'FeedWall')
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.imageDataUrl = data
            this.editImagePopup = true
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        reader.readAsArrayBuffer(file)
        // 
      } else {
        this.option.img = ''
        
        this.dialogVisible = false
        this.$vs.notify({
          title:'warning',
          text: 'Image sie is too large',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color:'warning'
        })
        return false
      }
    },
    onChange ({ canvas }) {
      // const imageToUpload = canvas.toDataURL();
      canvas.toBlob(blob => {
        const fd = new FormData()
        fd.append('files[]', blob, 'image.jpg')
        fd.append('upload_path', 'ads')
        this.cropImage = fd
      })
    },
    cancelImageUpload () {
      this.imageDataUrl = null
      this.editImagePopup = false
    },
    async getUploadFiles (file_id_payload, type = 'system') {
      this.$vs.notify({
        title: 'Success',
        text: 'File Uploaded Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 1000
      })        
     
      this.$emit('changingImage',file_id_payload[0].file_path)
    },
    async saveImage () {
      try {
        // const customer_id = this.$store.state.LoginStorage.user_details.customer_id
        const payload = this.$store.state.LoginStorage.user_details.customer_id
        const { data } = await UploadImage(this.cropImage, payload)
      
        const imageUrl = `${data.data.cdn}${data.data.files[0].file_path}`
        this.$emit('changingImage', imageUrl)
        this.imageDataUrl = null
        this.editImagePopup = false
        // 
        this.$vs.notify({
          title:'Success',
          text: 'file uploaded Successfully',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color:'success'
        })
      } catch (e) {
        this.$vs.notify({
          title:'error',
          text: e,
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color:'error'
        })
      }
    }
  }
}
</script>
<style>
.profile_image {
  border-radius: 50%;
  border: 1px solid #ccc;
}
@media only screen and (max-width: 1336px) {
  .profile_image {
    height:75px;
    width:75px;
    border-radius: 50%;
  }
}
</style>
